import { ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'apps/driver-dashboardfe/src/environments/environment';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { States } from 'apps/driver-dashboardfe/src/app/shared/constants/states.constant';
import { DialogHandlerService } from 'apps/driver-dashboardfe/src/app/core/services/dialog-handler/dialog-handler.service';
import { DriverService } from 'apps/driver-dashboardfe/src/app/core/services/driver/driver.service';
import { Subscription } from 'rxjs';
import { scripts } from 'apps/driver-dashboardfe/src/app/shared/constants/script.constant';
import { JoinService } from 'apps/driver-dashboardfe/src/app/core/services/join/join.service';
import { ScriptService } from 'apps/driver-dashboardfe/src/app/core/services/script/script.service';
import {
    startUserSessionMonitor,
    resetUserToken,
} from '../../shared/utitlity-functions/utility-functions';

@Component({
    standalone: false,
    selector: 'octo-complete',
    templateUrl: './complete.component.html',
    styleUrls: ['./complete.component.scss'],
})
export class CompleteComponent implements OnInit, OnDestroy {
    businessError: boolean = false;
    country: string = 'us';
    referraLink: string = '';
    env: string = environment.url;
    showCopySuccessMsg: boolean = false;
    addressForm: any;
    submitted: boolean = false;
    submitting: boolean = false;
    isForm: boolean = false;
    states: any;
    user: any;
    userData$ = new Subscription();
    zipPattern: any;
    adlibTag: any;
    fbPixelUs: any;
    fbPixelNoScriptUs: any;
    fbPixelCanada: any;
    fbPixelNoScriptCanada: any;
    rideshareTag: any;
    adlibTagComplete: any;
    gridWiseTag: any;
    gridWisePixel: any;
    blisCompletePixel: any;
    blisCompletedImage: any;
    atUniversalPixel: any;
    tiktokPixel: any;

    octoGooglePlacesAutocomplete = {
        googleAddressOptions: {
            componentRestrictions: { country: 'US' },
        },
        formGroup: null,
    };

    loading: boolean = true;
    isFedExPickup: boolean | null = null;
    allowShippingMethodChange: boolean = false;

    constructor(
        private fb: UntypedFormBuilder,
        private dialogService: DialogHandlerService,
        private driverService: DriverService,
        private joinService: JoinService,
        private renderer: Renderer2,
        private scriptService: ScriptService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        resetUserToken();
        startUserSessionMonitor();

        // pixel scripts
        if (environment.production && environment.shouldAddPixel) {
            this.adlibTag = this.scriptService.loadJsScript(
                this.renderer,
                scripts.adlib
            );
            this.adlibTagComplete = this.scriptService.loadJsScript(
                this.renderer,
                scripts['adlib-complete']
            );
            this.fbPixelUs = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-complete-registration-us']
            );
            this.fbPixelNoScriptUs = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-us']
            );
            this.fbPixelCanada = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-complete-registration-canada']
            );
            this.fbPixelNoScriptCanada = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-canada']
            );
            this.rideshareTag = this.scriptService.loadJsScript(
                this.renderer,
                scripts['RideShareAcquisition-2022-CompletePage']
            );

            this.blisCompletePixel = this.scriptService.loadJs(
                this.renderer,
                scripts['blis-completed']
            );

            this.blisCompletedImage = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['blis-completed-image']
            );

            this.atUniversalPixel = this.scriptService.loadJs(
                this.renderer,
                scripts['at-universal']
            );

            this.tiktokPixel = this.scriptService.loadJs(
                this.renderer,
                scripts['tiktok-base']
            );
        }

        this.initAddressForm();
        this.userData$ = this.joinService
            .getUserData()
            .subscribe((data: any) => {
                if (data) {
                    this.user = data;
                    this.country = data?.shipping_info.mailing_address_country;
                    this.referraLink = data?.referral_code;
                    this.setFormData(this.user);
                    this.states = this.country
                        ? States[this.country.toUpperCase()]
                        : [];
                    if (
                        this.user.referral_info?.referred_by?.toUpperCase() ==
                        'GRIDWISE'
                    ) {
                        // pixel scripts
                        this.gridWiseTag = this.scriptService.loadJsScript(
                            this.renderer,
                            scripts['gridwise-script-path']
                        );
                        this.gridWisePixel = this.scriptService.loadJs(
                            this.renderer,
                            scripts['gridwise-complete']
                        );
                    }

                    this.isFedExPickup =
                        this.user?.shipping_info?.is_fedex_pickup;
                    this.loading = false;
                }
            });
        this.addressForm.valueChanges.subscribe((val: any) => {
            this.businessError = false;
        });
    }

    copyToClipboard(event: any) {
        this.showCopySuccessMsg = true;
        setTimeout(() => (this.showCopySuccessMsg = false), 3000);
    }

    initAddressForm(): void {
        let pattern;
        this.country == 'us'
            ? (pattern = '^(\\d{5}(-\\d{4})?|\\d+$ *\\d[A-Z]\\d)$')
            : (pattern = '^([A-Za-z]\\d[A-Za-z][ -]?\\d[A-Za-z]\\d)$');

        this.addressForm = this.fb.group({
            address_line: ['', Validators.required],
            address_apartment_suite_no: ['', Validators.pattern(/^[^#]+$/)],
            address_city: ['', Validators.required],
            address_state: ['', Validators.required],
            address_country: ['US', Validators.required],
            address_zip: [
                '',
                [Validators.required, Validators.pattern(pattern)],
            ],
        });
        this.octoGooglePlacesAutocomplete.formGroup = this.addressForm;
    }

    setFormData(data: any): void {
        this.addressForm.patchValue({
            address_line: data.shipping_info.mailing_address_line,
            address_apartment_suite_no:
                data.shipping_info.mailing_address_apartment_suite_no,
            address_city: data.shipping_info.mailing_address_city,
            address_state: data.shipping_info.mailing_address_state,
            address_zip: data.shipping_info.mailing_address_zip,
            address_country: data.shipping_info.mailing_address_country,
        });
    }

    showForm(): void {
        this.setPattern();
        this.octoGooglePlacesAutocomplete = {
            googleAddressOptions: {
                componentRestrictions: { country: this.country },
            },
            formGroup: this.addressForm,
        };
        this.isForm = true;
    }

    hideForm(isResetShippingMethod: boolean = true): void {
        this.isForm = false;
        this.setFormData(this.user);

        this.isFedExPickup = this.user?.shipping_info?.is_fedex_pickup;

        if (isResetShippingMethod) {
            this.allowShippingMethodChange = false;
            this.loading = false;
        }
    }

    setPattern() {
        const zip = this.addressForm?.get('address_zip');
        this.country == 'US'
            ? (this.zipPattern = '^(\\d{5}(-\\d{4})?|\\d+$ *\\d[A-Z]\\d)$')
            : (this.zipPattern = '^([A-Za-z]\\d[A-Za-z][ -]?\\d[A-Za-z]\\d)$');
        if (zip) {
            zip.setValidators([
                Validators.required,
                Validators.pattern(this.zipPattern),
            ]);
            zip.updateValueAndValidity;
        }
    }

    fedexAddressValidation(): void {
        if (!this.addressForm.valid) {
            return;
        }
        const {
            address_line,
            address_apartment_suite_no: apartment,
            address_city,
            address_state,
            address_country,
            address_zip,
        } = this.addressForm.value;

        let payloadData = {
            address_line: address_line ? address_line.replace(/[#]/gi, '') : '',
            address_apartment_suite_no: apartment
                ? apartment.replace(/[#]/gi, '')
                : '',
            address_city: address_city,
            address_state: address_state,
            address_country: address_country,
            address_zip: address_zip,
        };

        let address = address_line;
        if (apartment) {
            address = `${address}, ${apartment}`;
        }
        address = `${address}, ${address_city}, ${address_state}, ${address_country} - ${address_zip}`;
        let poExists = false;
        const setOfStrings = ['po box', 'p.o. box', 'p.o.box'];
        const addressLine = address_line.toLowerCase();
        const apartmentSuiteNo = apartment ? apartment.toLowerCase() : '';
        poExists = setOfStrings.some(
            (item) =>
                addressLine.includes(item) || apartmentSuiteNo.includes(item)
        );
        if (poExists) {
            let fields = [];
            fields.push({
                type: 'hidden',
                name: 'address',
                value: payloadData,
                label: address,
                head: 'You Entered:',
            });
            this.dialogService
                .showFedexAddressSuggestion({
                    title: 'Warning',
                    fields: fields,
                    hasSuggestions: false,
                    errorMessage: 'Note: We cannot ship to P.O. boxes',
                    isRadio: true,
                })
                .subscribe((data) => this.updateAddress(data));
            return;
        }

        if (this.user.shipping_info?.is_fedex_pickup === true) {
            let shippingMessage = `Are you sure you want to select FedEx Home Delivery as your shipping method?`;
            shippingMessage += `<br><br><small class="bold-text">Note: Signature is required to complete the delivery.</small>`;

            this.dialogService
                .confirmAction({
                    title: 'Confirm Shipping Method',
                    message: shippingMessage,
                })
                .subscribe((data: any) => {
                    if (data) {
                        this.runFedexAddressValidation(
                            payloadData,
                            address,
                            address_line,
                            apartment
                        );
                    } else {
                        // If the user cancels the shipping method, reset the shipping method to the previous value.
                        this.isFedExPickup = false;
                    }

                    this.loading = false;
                    this.allowShippingMethodChange = true;
                });
        } else {
            this.runFedexAddressValidation(
                payloadData,
                address,
                address_line,
                apartment
            );
        }
    }

    runFedexAddressValidation(
        payloadData: any,
        address: any,
        address_line: string,
        apartment: string | null
    ) {
        this.submitting = true;
        this.joinService.getFedExSuggestion(payloadData).subscribe({
            next: (resp) => {
                this.submitting = false;
                let suggestedAddresses: any = [];
                let addressError = '';
                let fedexSuggestion = resp.data;
                let isSameAddress = false;
                let showInvalidAptNote = false;
                let isSuiteNumberRequired = false;
                let isStreetNumberIncorrect = false;
                let hasSuggestions = false;
                let businessAddress = false;

                if (!resp.success && !fedexSuggestion?.length) {
                    suggestedAddresses.push({
                        type: 'radio',
                        name: 'address',
                        value: payloadData,
                        label: address,
                        head: 'You Entered:',
                    });
                    hasSuggestions = false;
                    addressError =
                        'Warning! We could not find any addresses that match this entry.';
                    this.dialogService
                        .showFedexAddressSuggestion({
                            title: 'Warning!',
                            fields: suggestedAddresses,
                            hasSuggestions: hasSuggestions,
                            errorMessage: addressError,
                            isRadio: true,
                        })
                        .subscribe((data) => this.updateAddress(data));
                    return;
                }
                if (resp.success && !fedexSuggestion?.length) {
                    this.submitAddress();
                } else {
                    for (var i = 0; i < fedexSuggestion.length; i++) {
                        // fedexSuggestion.forEach((addr: any, i: number) => {
                        let addr = fedexSuggestion[i];
                        const vL1Changed = addr.street_line !== address_line;
                        const vL2Changed =
                            apartment && apartment !== addr.apartment_line;
                        if (
                            addr.is_resolved &&
                            !addr.po_box &&
                            addr.address_type === 'STANDARDIZED'
                        ) {
                            let addressRow = `<span ${
                                vL1Changed ? `class='highlight'` : ''
                            }>${addr.street_line},</span>
                        <span ${vL2Changed ? `class='highlight'` : ''}>${
                                addr.apartment_line
                                    ? addr.apartment_line + ', '
                                    : ''
                            }${
                                addr.is_invalid_suite_number
                                    ? '<sup>*</sup>'
                                    : ''
                            }</span>
                        <span ${
                            addr.is_city_changed ? `class='highlight'` : ''
                        }>${addr.city}, </span>
                        <span ${
                            addr.is_state_changed ? `class='highlight'` : ''
                        }>${addr.state}, </span>
                        <span>${addr.country} - </span>
                        <span ${
                            addr.is_zip_changed ? `class='highlight'` : ''
                        }>${addr.zip_code}</span>`;

                            if (
                                !showInvalidAptNote &&
                                addr.is_invalid_suite_number
                            ) {
                                showInvalidAptNote = true;
                            }
                            if (
                                !businessAddress &&
                                addr.classification === 'BUSINESS'
                            ) {
                                businessAddress = true;
                            }
                            if (
                                (!isSuiteNumberRequired &&
                                    addr.error_messages.includes(
                                        'SUITE.NUMBER.REQUIRED'
                                    )) ||
                                addr.error_messages.includes(
                                    'INVALID.SUITE.NUMBER'
                                )
                            ) {
                                isSuiteNumberRequired = true;
                            }
                            if (
                                !isStreetNumberIncorrect &&
                                addr.error_messages.includes(
                                    'INTERPOLATED.STREET.ADDRESS'
                                )
                            ) {
                                isStreetNumberIncorrect = true;
                            }
                            if (
                                !isSameAddress &&
                                !vL1Changed &&
                                !vL2Changed &&
                                !addr.is_city_changed &&
                                !addr.is_state_changed &&
                                !addr.is_zip_changed
                            ) {
                                isSameAddress = true;
                                if (fedexSuggestion.length == 1) {
                                    this.submitAddress();
                                    return;
                                } else return;
                            }

                            //Add entered address in the address suggestion modal
                            suggestedAddresses.push({
                                type:
                                    isStreetNumberIncorrect || businessAddress
                                        ? 'hidden'
                                        : 'radio',
                                name: 'address',
                                value: payloadData,
                                label: address,
                                head: 'You Entered:',
                            });
                            if (!isStreetNumberIncorrect && !businessAddress) {
                                suggestedAddresses.push({
                                    head: i === 0 ? 'We Suggest' : '',
                                    type: 'radio',
                                    name: 'address',
                                    value: {
                                        address_line: addr.street_line
                                            ? addr.street_line.replace(
                                                  /[#]/gi,
                                                  ''
                                              )
                                            : '',
                                        address_apartment_suite_no:
                                            addr.apartment_line
                                                ? addr.apartment_line.replace(
                                                      /[#]/gi,
                                                      ''
                                                  )
                                                : '',
                                        address_city: addr.city,
                                        address_state: addr.state,
                                        address_country: addr.country,
                                        address_zip: addr.zip_code,
                                    },
                                    label: addressRow,
                                });
                                hasSuggestions = true;
                            } else {
                                addressError = businessAddress
                                    ? 'Warning: Your permanent address must be a residential address.'
                                    : 'Warning! We could not find any addresses that match this entry.';
                                hasSuggestions = false;
                            }
                        } else {
                            suggestedAddresses.push({
                                type: 'hidden',
                                name: 'address',
                                value: payloadData,
                                label: address,
                                head: 'You Entered:',
                            });
                            hasSuggestions = false;
                            if (
                                !businessAddress &&
                                addr.classification === 'BUSINESS'
                            ) {
                                businessAddress = true;
                                this.submitting = false;
                                this.businessError = true;
                            }
                            addressError = addr.po_box
                                ? 'Note: We cannot ship to P.O. boxes'
                                : businessAddress
                                ? 'Warning: Your permanent address must be a residential address.'
                                : 'Warning! We could not find any addresses that match this entry.';
                        }
                    }

                    //Check if there is any content to be displayed in fedex address suggestion
                    if (addressError || suggestedAddresses.length) {
                        if (hasSuggestions) {
                            this.dialogService
                                .showFedexAddressSuggestion({
                                    title: 'Warning!',
                                    fields: suggestedAddresses,
                                    hasSuggestions: hasSuggestions,
                                    errorMessage: addressError,
                                })
                                .subscribe((data) => this.updateAddress(data));
                        } else if (businessAddress) {
                            this.dialogService
                                .showContinueWithoutFedEx({
                                    title: 'Warning!',
                                    fields: suggestedAddresses,
                                    hasSuggestions: false,
                                    withoutValidation: false,
                                    errorMessage: addressError,
                                    isRadio: true,
                                })
                                .subscribe((data) => this.updateAddress(data));
                        } else {
                            this.dialogService
                                .showContinueWithoutFedEx({
                                    title: 'Warning!',
                                    fields: suggestedAddresses,
                                    hasSuggestions: false,
                                    withoutValidation: false,
                                    errorMessage: addressError,
                                    isRadio: true,
                                })
                                .subscribe((data) => this.updateAddress(data));
                        }
                        return;
                    }
                }

                // this.submitInfo(); to do
            },
            error: (error: any) => {
                this.submitting = false;
                let suggestedAddresses: any = [];
                suggestedAddresses.push({
                    type: 'radio',
                    name: 'address',
                    value: payloadData,
                    label: address,
                    head: 'You Entered:',
                });
                this.dialogService
                    .showFedexAddressSuggestion({
                        title: 'Warning!',
                        fields: suggestedAddresses,
                        hasSuggestions: false,
                        errorMessage:
                            'Warning! We could not find any addresses that match this entry.',
                        isRadio: true,
                    })
                    .subscribe((data) => this.updateAddress(data));
                return;
            },
        });
    }

    updateAddress(data: any) {
        if (data.selectedAddress) {
            this.addressForm.patchValue({ ...data.selectedAddress });
            this.submitAddress();
        } else {
            this.setFormData(this.user);
        }
    }

    submitAddress() {
        this.submitted = true;
        this.joinService
            .getCities(this.addressForm?.value.address_zip.split('-')[0])
            .subscribe((data) => {
                const temp = {
                    latitude: data.data?.latitude,
                    longitude: data.data?.longitude,
                    shipping_info: {
                        mailing_address_apartment_suite_no:
                            this.addressForm?.value.address_apartment_suite_no,
                        mailing_address_city:
                            this.addressForm?.value.address_city,
                        mailing_address_country:
                            this.addressForm?.value.address_country,
                        mailing_address_line:
                            this.addressForm?.value.address_line,
                        mailing_address_state:
                            this.addressForm?.value.address_state,
                        mailing_address_zip:
                            this.addressForm?.value.address_zip,
                    },
                };
                this.joinService
                    .editJoinDetails(this.user.id, temp)
                    .subscribe((data) => {
                        this.submitted = false;
                        this.joinService.setUserData(data.data);
                        this.isForm = false;

                        this.allowShippingMethodChange = false;
                        this.loading = false;
                    });
            });
    }

    /**
     * Show options to change the shipping method.
     */
    onShippingChange() {
        this.loading = false;
        this.allowShippingMethodChange = true;

        if (this.isFedExPickup) {
            this.hideForm(false);
            this.isFedExPickup = true;

            if (!this.user.shipping_info?.fedex_location) {
                let shippingMessage = `Are you sure you want to select FedEx Pickup as your shipping method?`;
                shippingMessage += `<br><br><small class=bold-text>By selecting FedEx Pickup, you are agreeing to have your order shipped to a FedEx location for pickup.</small>`;

                this.dialogService
                    .confirmAction({
                        title: 'Confirm Shipping Method',
                        message: shippingMessage,
                    })
                    .subscribe((data: any) => {
                        if (data) {
                            this.showFedExLocationLookupDialog();
                        }
                        this.loading = false;
                        this.allowShippingMethodChange = true;
                        this.cdr.detectChanges();
                    });
            } else if (!this.user.shipping_info?.is_fedex_pickup) {
                this.dialogService
                    .confirmAction({
                        title: 'Confirm Shipping Method',
                        message: `Are you sure you want to ship your tablet to the following FedEx location? <br><br> <span class=bold-text>${this.user?.shipping_info?.fedex_location?.location_name}</span><br></br>${this.user?.shipping_info?.fedex_location?.address}`,
                        cancelBtnText: 'Change',
                        confirmBtnText: 'Confirm',
                    })
                    .subscribe((data: any) => {
                        if (data) {
                            this.driverService
                                .selectFedExLocation({
                                    location_id:
                                        this.user?.shipping_info?.fedex_location
                                            ?.location_id,
                                    location_name:
                                        this.user?.shipping_info?.fedex_location
                                            ?.location_name,
                                    address:
                                        this.user?.shipping_info?.fedex_location
                                            ?.address,
                                    email_address:
                                        this.user?.shipping_info?.fedex_location
                                            ?.email_address,
                                    phone_number:
                                        this.user?.shipping_info?.fedex_location
                                            ?.phone_number,
                                    distance:
                                        this.user?.shipping_info?.fedex_location
                                            ?.distance,
                                    store_hours:
                                        this.user?.shipping_info?.fedex_location
                                            ?.store_hours,
                                })
                                .subscribe((response) => {
                                    if (response.success) {
                                        this.joinService
                                            .getJoinDetails()
                                            .subscribe((data) => {
                                                this.joinService.setUserData(
                                                    data.data
                                                );
                                            });

                                        this.allowShippingMethodChange = false;
                                        this.loading = false;
                                        this.cdr.detectChanges();
                                    } else {
                                        this.dialogService.alert({
                                            title: 'Error',
                                            message:
                                                response.message ||
                                                'An error occurred while selecting the FedEx location. Please try again.',
                                        });
                                    }
                                });
                        } else {
                            this.showFedExLocationLookupDialog();
                        }
                    });
            }
        } else {
            this.showForm();
        }
    }

    /**
     * Show the FedEx Location Lookup dialog.
     */
    showFedExLocationLookupDialog() {
        this.dialogService
            .showFedexLocationLookupDialog({
                location: `${
                    this.user?.shipping_info?.mailing_address_line || ''
                } ${this.user?.shipping_info?.mailing_address_city} ${
                    this.user?.shipping_info?.mailing_address_state
                } ${this.user?.shipping_info?.mailing_address_zip}`,
                address_line: this.user?.shipping_info?.mailing_address_line || '',
                address_city: this.user?.shipping_info?.mailing_address_city || '',
                address_state: this.user?.shipping_info?.mailing_address_state || '',
                address_zip: this.user?.shipping_info?.mailing_address_zip || '',
            })
            .subscribe((data: any) => {
                if (data) {
                    if (data?.status > 400) {
                        if (data?.status == 404) {
                            this.dialogService.alert({
                                title: 'Error',
                                message:
                                    'No FedEx location found. Please try again.',
                            });
                        } else {
                            this.dialogService.alert({
                                title: 'Error',
                                message:
                                    data?.statusText ||
                                    'An error occurred while fetching the FedEx location. Please try again.',
                            });
                        }

                        return;
                    }
                    this.loading = true;

                    this.joinService.getJoinDetails().subscribe((data) => {
                        this.joinService.setUserData(data.data);
                    });

                    this.allowShippingMethodChange = false;
                    this.loading = false;
                    this.cdr.detectChanges();
                } else {
                    this.loading = false;
                    this.cdr.detectChanges();
                }
            });
    }

    ngOnDestroy(): void {
        this.userData$.unsubscribe();
        if (environment.production && environment.shouldAddPixel) {
            this.scriptService.removeScript(this.renderer, this.adlibTag);
            this.scriptService.removeScript(this.renderer, this.fbPixelUs);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelNoScriptUs
            );
            this.scriptService.removeScript(this.renderer, this.fbPixelCanada);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelNoScriptCanada
            );
            this.scriptService.removeScript(
                this.renderer,
                this.blisCompletePixel
            );
            this.scriptService.removeScript(
                this.renderer,
                this.blisCompletedImage
            );
            this.scriptService.removeScript(
                this.renderer,
                this.adlibTagComplete
            );
            this.scriptService.removeScript(this.renderer, this.rideshareTag);
            if (
                this.user.referral_info?.referred_by?.toUpperCase() ==
                'GRIDWISE'
            ) {
                this.scriptService.removeScript(
                    this.renderer,
                    this.gridWiseTag
                );
                this.scriptService.removeScript(
                    this.renderer,
                    this.gridWisePixel
                );
            }
            this.scriptService.removeScript(
                this.renderer,
                this.atUniversalPixel
            );
            this.scriptService.removeScript(this.renderer, this.tiktokPixel);
        }
    }
}
